'use client'

import Link from 'next/link'
import { useTheme } from '@/contexts/ThemeContext'
import { ArrowLeft, MapPin } from 'lucide-react'

export default function WestSeaPage() {
  const { theme } = useTheme()
  const isDark = theme === 'dark'

  const spots = [
    { id: 'taean', name: '태안 만리포', depth: '5-15m', level: '초급 가능', features: ['넓은 해변', '가족 단위 추천'] },
    { id: 'boryeong', name: '보령 무창포', depth: '8-20m', level: '초중급', features: ['신비의 바닷길', '독특한 경험'] },
    { id: 'gunsan', name: '군산 선유도', depth: '10-25m', level: '중급', features: ['섬 투어', '아름다운 낙조'] },
  ]

  return (
    <div className={`min-h-screen py-4 xxs:py-3 px-3 xxs:px-2 ${
      isDark ? 'bg-gray-900' : 'bg-gradient-to-b from-cyan-50 to-white'
    }`}>
      <div className="max-w-4xl mx-auto">
        <Link
          href="/spots"
          className={`inline-flex items-center gap-1 mb-4 xxs:mb-3 text-sm xxs:text-xs ${
            isDark ? 'text-blue-400 hover:text-blue-300' : 'text-blue-600 hover:text-blue-700'
          }`}
        >
          <ArrowLeft className="w-4 h-4 xxs:w-3.5 xxs:h-3.5" />
          바다 포인트 목록
        </Link>

        <div className="mb-6 xxs:mb-4">
          <h1 className={`text-2xl xxs:text-xl font-bold mb-2 xxs:mb-1 ${isDark ? 'text-white' : 'text-gray-900'}`}>
            서해안 다이빙 포인트
          </h1>
          <p className={`text-sm xxs:text-xs ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
            서해안의 대표적인 프리다이빙 포인트 {spots.length}곳을 소개합니다.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 xxs:gap-3">
          {spots.map((spot) => (
            <div
              key={spot.id}
              className={`p-5 xxs:p-4 rounded-xl shadow-md ${
                isDark ? 'bg-gray-800' : 'bg-white'
              }`}
            >
              <div className="flex items-start gap-2 mb-3 xxs:mb-2">
                <MapPin className={`w-5 h-5 xxs:w-4 xxs:h-4 flex-shrink-0 ${isDark ? 'text-blue-400' : 'text-blue-600'}`} />
                <h3 className={`text-lg xxs:text-base font-bold ${isDark ? 'text-white' : 'text-gray-900'}`}>
                  {spot.name}
                </h3>
              </div>
              <div className={`space-y-1.5 xxs:space-y-1 text-sm xxs:text-xs mb-4 xxs:mb-3 ${isDark ? 'text-gray-300' : 'text-gray-600'}`}>
                <p>🌊 수심: {spot.depth}</p>
                <p>⭐ 추천 레벨: {spot.level}</p>
              </div>
              <div className="flex flex-wrap gap-2 xxs:gap-1">
                {spot.features.map((feature, idx) => (
                  <span
                    key={idx}
                    className={`px-3 xxs:px-2 py-1 text-sm xxs:text-xs rounded-full ${
                      isDark
                        ? 'bg-blue-900/50 text-blue-200'
                        : 'bg-blue-100 text-blue-800'
                    }`}
                  >
                    {feature}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* 버디 매칭 CTA */}
        <div className={`mt-6 xxs:mt-4 p-5 xxs:p-4 rounded-xl ${isDark ? 'bg-blue-900/20' : 'bg-blue-50'}`}>
          <h3 className={`font-bold text-base xxs:text-sm mb-2 ${isDark ? 'text-blue-300' : 'text-blue-800'}`}>
            서해에서 함께 다이빙할 버디를 찾아보세요
          </h3>
          <p className={`text-sm xxs:text-xs mb-4 xxs:mb-3 ${isDark ? 'text-blue-200/80' : 'text-blue-700'}`}>
            오늘다이빙에서 서해안 다이빙 버디를 매칭받으세요!
          </p>
          <Link
            href="/matching/new"
            className="inline-block px-5 xxs:px-4 py-2.5 xxs:py-2 text-sm xxs:text-xs font-medium bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
          >
            버디 매칭 신청
          </Link>
        </div>
      </div>
    </div>
  )
}
